import { autoinject } from "aurelia-framework";

/**
 * Represents the header of a toast.
 */
@autoinject
export class ToastHeaderCustomElement
{
}
